"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EPaymentStatus;
(function (EPaymentStatus) {
    EPaymentStatus["PENDING"] = "PENDING";
    EPaymentStatus["UPCOMING"] = "UPCOMING";
    EPaymentStatus["APPROVED"] = "APPROVED";
    EPaymentStatus["DECLINED"] = "DECLINED";
    EPaymentStatus["PENDING_APPROVAL"] = "PENDING_APPROVAL";
    EPaymentStatus["PARTIALLY_REFUNDED"] = "PARTIALLY_REFUNDED";
    EPaymentStatus["REFUNDED"] = "REFUNDED";
    EPaymentStatus["VOIDED"] = "VOIDED";
    EPaymentStatus["CHARGEBACK"] = "CHARGEBACK";
    EPaymentStatus["SKIPPED"] = "SKIPPED";
})(EPaymentStatus = exports.EPaymentStatus || (exports.EPaymentStatus = {}));
var EPaymentReceiptType;
(function (EPaymentReceiptType) {
    EPaymentReceiptType["EMAIL"] = "EMAIL";
    EPaymentReceiptType["ADDRESS"] = "ADDRESS";
    EPaymentReceiptType["PRINT"] = "PRINT";
    EPaymentReceiptType["PRINT_RECEIPT"] = "PRINT_RECEIPT";
})(EPaymentReceiptType = exports.EPaymentReceiptType || (exports.EPaymentReceiptType = {}));
var EPaymentType;
(function (EPaymentType) {
    EPaymentType["AUTO_PAY"] = "AUTO_PAY";
    EPaymentType["SCHEDULED"] = "SCHEDULED";
})(EPaymentType = exports.EPaymentType || (exports.EPaymentType = {}));
var EAutoPayType;
(function (EAutoPayType) {
    EAutoPayType["BILL_MAX_ONLY"] = "BILL_MAX_ONLY";
    EAutoPayType["BILL_ANYWAY"] = "BILL_ANYWAY";
    EAutoPayType["BILL_MONTH_DUE"] = "BILL_MONTH_DUE";
    EAutoPayType["BILL_FULL_DUE"] = "BILL_FULL_DUE";
})(EAutoPayType = exports.EAutoPayType || (exports.EAutoPayType = {}));
var EAutoPayOffset;
(function (EAutoPayOffset) {
    EAutoPayOffset["PREVIOUS_MONTH"] = "PREVIOUS_MONTH";
    EAutoPayOffset["CURRENT_MONTH"] = "CURRENT_MONTH";
    EAutoPayOffset["NEXT_MONTH"] = "NEXT_MONTH";
})(EAutoPayOffset = exports.EAutoPayOffset || (exports.EAutoPayOffset = {}));
var EPaymentScheduleStatus;
(function (EPaymentScheduleStatus) {
    EPaymentScheduleStatus["SCHEDULED"] = "SCHEDULED";
    EPaymentScheduleStatus["SUSPENDED"] = "SUSPENDED";
    EPaymentScheduleStatus["DELETED"] = "DELETED";
})(EPaymentScheduleStatus = exports.EPaymentScheduleStatus || (exports.EPaymentScheduleStatus = {}));
var EPaymentRefundStatus;
(function (EPaymentRefundStatus) {
})(EPaymentRefundStatus = exports.EPaymentRefundStatus || (exports.EPaymentRefundStatus = {}));
var EPaymentMethodType;
(function (EPaymentMethodType) {
    EPaymentMethodType["CREDIT_CARD"] = "CREDIT_CARD";
    EPaymentMethodType["ECHECK"] = "ECHECK";
})(EPaymentMethodType = exports.EPaymentMethodType || (exports.EPaymentMethodType = {}));
var EPaymentTypes;
(function (EPaymentTypes) {
    EPaymentTypes["ONE_TIME_PAYMENT"] = "ONE_TIME_PAYMENT";
    EPaymentTypes["SCHEDULED_PAYMENT"] = "SCHEDULED_PAYMENT";
    EPaymentTypes["AUTO_PAYMENT"] = "AUTO_PAYMENT";
})(EPaymentTypes = exports.EPaymentTypes || (exports.EPaymentTypes = {}));
var EPaymentsDepositStatus;
(function (EPaymentsDepositStatus) {
    EPaymentsDepositStatus["IDLE"] = "IDLE";
    EPaymentsDepositStatus["PROCESSING"] = "PROCESSING";
    EPaymentsDepositStatus["ERROR"] = "ERROR";
    EPaymentsDepositStatus["SYNCED"] = "SYNCED";
    EPaymentsDepositStatus["NA"] = "N/A";
})(EPaymentsDepositStatus = exports.EPaymentsDepositStatus || (exports.EPaymentsDepositStatus = {}));
var ESchedulePaymentCycle;
(function (ESchedulePaymentCycle) {
    ESchedulePaymentCycle["WEEKLY"] = "WEEKLY";
    ESchedulePaymentCycle["MONTHLY"] = "MONTHLY";
})(ESchedulePaymentCycle = exports.ESchedulePaymentCycle || (exports.ESchedulePaymentCycle = {}));
var ESchedulePaymentSettingStatus;
(function (ESchedulePaymentSettingStatus) {
    ESchedulePaymentSettingStatus["ACTIVE"] = "ACTIVE";
    ESchedulePaymentSettingStatus["DELETED"] = "DELETED";
    ESchedulePaymentSettingStatus["COMPLETE"] = "COMPLETE";
})(ESchedulePaymentSettingStatus = exports.ESchedulePaymentSettingStatus || (exports.ESchedulePaymentSettingStatus = {}));
var EAutoPaySettingStatus;
(function (EAutoPaySettingStatus) {
    EAutoPaySettingStatus["ACTIVE"] = "ACTIVE";
    EAutoPaySettingStatus["DELETED"] = "DELETED";
    EAutoPaySettingStatus["COMPLETE"] = "COMPLETE";
})(EAutoPaySettingStatus = exports.EAutoPaySettingStatus || (exports.EAutoPaySettingStatus = {}));
var ESchedulePaymentItemStatus;
(function (ESchedulePaymentItemStatus) {
    ESchedulePaymentItemStatus["SCHEDULED"] = "SCHEDULED";
    ESchedulePaymentItemStatus["NEEDS_REVIEW"] = "NEEDS_REVIEW";
    ESchedulePaymentItemStatus["PAID"] = "PAID";
    ESchedulePaymentItemStatus["DECLINED"] = "DECLINED";
    ESchedulePaymentItemStatus["DELETED"] = "DELETED";
    ESchedulePaymentItemStatus["SKIPPED"] = "SKIPPED";
})(ESchedulePaymentItemStatus = exports.ESchedulePaymentItemStatus || (exports.ESchedulePaymentItemStatus = {}));
var ESchedulePaymentItemType;
(function (ESchedulePaymentItemType) {
    ESchedulePaymentItemType["SCHEDULE"] = "SCHEDULE";
    ESchedulePaymentItemType["AUTO_PAY"] = "AUTO_PAY";
})(ESchedulePaymentItemType = exports.ESchedulePaymentItemType || (exports.ESchedulePaymentItemType = {}));
var EAutoPayItemStatus;
(function (EAutoPayItemStatus) {
    EAutoPayItemStatus["SCHEDULED"] = "SCHEDULED";
    EAutoPayItemStatus["NEEDS_REVIEW"] = "NEEDS_REVIEW";
    EAutoPayItemStatus["PAID"] = "PAID";
    EAutoPayItemStatus["DECLINED"] = "DECLINED";
    EAutoPayItemStatus["DELETED"] = "DELETED";
    EAutoPayItemStatus["SKIPPED"] = "SKIPPED";
    EAutoPayItemStatus["UPCOMING"] = "UPCOMING";
    EAutoPayItemStatus["NO_BALANCE"] = "NO_BALANCE";
    EAutoPayItemStatus["DEACTIVATED"] = "DEACTIVATED";
})(EAutoPayItemStatus = exports.EAutoPayItemStatus || (exports.EAutoPayItemStatus = {}));
